document.addEventListener("DOMContentLoaded", function () {
  const collectionGridSections = document?.querySelectorAll(
    ".collection-grid-list",
  );
  const modalImageEl = document?.querySelector("#image-modal");
  const modalImageElWrapper = modalImageEl?.querySelector(".section-wrapper");
  const modalImageWrapper = modalImageEl?.querySelector(".image-wrapper");
  const closeModalImage = modalImageEl?.querySelector(".close-btn");

  collectionGridSections?.forEach((section) => {
    const contentBtn = section?.querySelector(".btn-wrapper Button");
    const contentBackBtn = section?.querySelector(".back-btn");
    const imagesEl = section?.querySelectorAll(".image-wrapper");

    contentBtn?.addEventListener("click", function () {
      section?.classList?.add("show-content");
    });
    contentBackBtn?.addEventListener("click", function () {
      section?.classList?.remove("show-content");
    });
    imagesEl?.forEach((el) => {
      const imageSrc = el?.dataset?.image;
      el?.addEventListener("click", function () {
        if (imageSrc && modalImageEl) {
          modalImageEl?.classList?.add("active");
          const img = new Image();
          img.src = imageSrc;
          img.onload = () => {
            modalImageWrapper.innerHTML = "";
            modalImageWrapper.appendChild(img);
          };
        }
      });
    });
  });
  modalImageEl?.addEventListener("click", function () {
    modalImageEl?.classList?.remove("active");
    modalImageWrapper.innerHTML = "";
  });
  modalImageElWrapper?.addEventListener("click", function (e) {
    e?.stopPropagation();
  });
  closeModalImage?.addEventListener("click", function (e) {
    modalImageEl?.classList?.remove("active");
    modalImageWrapper.innerHTML = "";
  });
});
